<template>
  <svg
    width="535"
    height="536"
    viewBox="0 0 535 536"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_3731_35751)">
      <ellipse
        cx="267.75"
        cy="268"
        rx="42.1875"
        ry="210.938"
        fill="var(--brand-primary)"
      />
    </g>
    <g filter="url(#filter1_f_3731_35751)">
      <ellipse
        cx="267.753"
        cy="268"
        rx="42.1875"
        ry="210.938"
        transform="rotate(-45 267.753 268)"
        fill="var(--brand-primary)"
      />
    </g>
    <g filter="url(#filter2_f_3731_35751)">
      <ellipse
        cx="267.754"
        cy="268"
        rx="42.1875"
        ry="210.938"
        transform="rotate(45 267.754 268)"
        fill="var(--brand-primary)"
      />
    </g>
    <g filter="url(#filter3_f_3731_35751)">
      <path
        d="M267.75 225.812C384.247 225.812 478.687 244.7 478.687 268C478.687 291.3 384.247 310.188 267.75 310.188C151.252 310.188 56.8124 291.3 56.8124 268C56.8124 244.7 151.252 225.812 267.75 225.812Z"
        fill="var(--brand-primary)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_3731_35751"
        x="169.312"
        y="0.8125"
        width="196.875"
        height="534.375"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="28.125"
          result="effect1_foregroundBlur_3731_35751"
        />
      </filter>
      <filter
        id="filter1_f_3731_35751"
        x="59.364"
        y="59.6108"
        width="416.777"
        height="416.777"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="28.125"
          result="effect1_foregroundBlur_3731_35751"
        />
      </filter>
      <filter
        id="filter2_f_3731_35751"
        x="59.3651"
        y="59.6108"
        width="416.777"
        height="416.777"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="28.125"
          result="effect1_foregroundBlur_3731_35751"
        />
      </filter>
      <filter
        id="filter3_f_3731_35751"
        x="0.562431"
        y="169.562"
        width="534.375"
        height="196.875"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="28.125"
          result="effect1_foregroundBlur_3731_35751"
        />
      </filter>
    </defs>
  </svg>
</template>
